import { useAuth } from './AuthorizationFetch';

const useRecruitsAddFetch = () => {

    const { authenticatedFetch } = useAuth();

    const addRecruit = async (recruitData) => {
      try {
        const response = await authenticatedFetch(`${process.env.REACT_APP_BASE_URL}/recruits/add`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json', // This indicates you are sending JSON
          },
          body: JSON.stringify(recruitData),
        });
  
        if (!response.ok) {
          console.log("POST: ", await response.json())
          throw new Error('Failed to add recruit');
        }
        console.log("POST: ", response.json)
        return await response.json();
      } catch (error) {
        console.error('Error adding recruit:', error);
        throw error;
      }
    };
  
    return { addRecruit };
  };
  
  export default useRecruitsAddFetch;
  